import { Redirect, Route } from 'react-router-dom';
import { useAuthentication } from 'hooks/AuthenticationHook';
import { PORTAL } from 'routes/portal';
import PageLayout from 'components/PageLayout';
import AudioPlayer from 'components/AudioPlayer';

const PrivateRoute = ({ component: Component, ...rest }) => {
  let { isAuthenticated, isVenueManager } = useAuthentication();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated()) {
          return <Redirect to={PORTAL.LOGIN} />;
        }

        const venueOnlyRoute =
          typeof rest.path === 'string' &&
          rest.path.startsWith('/events-manager');
        const venueUser = isVenueManager();

        if (venueUser && !venueOnlyRoute) {
          return <Redirect to="/events-manager/upload-event-recording" />;
        }

        return (
          <>
            <PageLayout component={<Component {...props} />} />
            <div
              className="bg-white h-12"
              style={{
                position: 'fixed',
                bottom: '0px',
                left: '257px',
                height: '68px',
                width: '100%',
              }}
            >
              <AudioPlayer />
            </div>
          </>
        );
      }}
    />
  );
};
export default PrivateRoute;
